import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect } from "react";
import { UserContext } from "../../context/UserContext";
import { getConnectedStations, getLocationProductivity } from '../../services/station';
import { getUserConfig } from "../../services/user";
import BoardView from "./BoardView";
import ScanView from "./ScanView";
import StationProductivity from "./StationProductivity";
import styles from './Beamsaw.module.css';
import SubHeader from "../../components/SubHeader";
import StationSelection from "../../components/StationSelection";

function Beamsaw() {
  const {setAvailableLocations, workOrder, selectedLocation, currentFactory} = useContext(UserContext);
  const {data: userConfig, isLoading: userConfigLoading} = useQuery(['userConfig', selectedLocation.location], () => getUserConfig(
    {
      location: selectedLocation.location,
      _factory_code: currentFactory.item_code
    }
  ), {
    refetchOnWindowFocus: false
  })

  const {data: locationStatus, isLoading: locationLoading} = useQuery(['locationProductivity', selectedLocation.location], () => getLocationProductivity(
    {
      location: selectedLocation.location,
      _factory_code: currentFactory.item_code,
      station: "beamsaw",
      startdate: new Date(new Date().toDateString())
    }
  ), {
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: 1000
  })

  useEffect(() => {
    loadData();
  }, [currentFactory.item_code])

  async function loadData() {
    let connectedStations = await getConnectedStations({
      _factory_code: currentFactory.item_code,
      station: "beamsaw"
    });

    setAvailableLocations(connectedStations.message?.stations);
  }

  return (
    <>
      <SubHeader showWorkOrder={true} showSearch={true} showBackButton={false} subTitle={'Beamsaw'} right={<StationSelection />}></SubHeader>
      <div className="p-24">
        <StationProductivity loading={userConfigLoading || locationLoading} locationStatus={locationStatus?.message || {} } userConfig={userConfig?.message || {}}></StationProductivity>
        <ScanView></ScanView>
        {workOrder && workOrder.id != undefined && <BoardView></BoardView>}
        {(!workOrder || workOrder.id === undefined) && <div className={styles.errorWo}>Kindly search and select workorder to continue scanning</div>}
      </div>
    </>
  );
}

export default Beamsaw;
